import { render, staticRenderFns } from "./report-tag.vue?vue&type=template&id=8265cdd6&scoped=true"
import script from "./report-tag.vue?vue&type=script&lang=js"
export * from "./report-tag.vue?vue&type=script&lang=js"
import style0 from "./report-tag.vue?vue&type=style&index=0&id=8265cdd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8265cdd6",
  null
  
)

export default component.exports